module.exports = __webpack_public_path__ + "img/will_being_read.62ce120f.svg";